import { render, staticRenderFns } from "./TgDatePicker.vue?vue&type=template&id=52efcf20"
import script from "./TgDatePicker.vue?vue&type=script&lang=js"
export * from "./TgDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports